import { useEffect } from "react";
import type { HomeDashboardRepository } from "../../application/home-dashboard";
import type { MealRepository } from "../../application/meal-repository";
import { generateReports } from "../../application/statistics-reports";
import { reportClientError } from "../../application/client-error-logger";

export function useAutomaticReports(dashboards: HomeDashboardRepository, meals: MealRepository) {
  useEffect(() => {
    const run = () => { if (document.visibilityState === "visible") void generateReports(dashboards, meals).catch(error => reportClientError(error, { area: "statistics", action: "automatic_reports" })); };
    run();
    document.addEventListener("visibilitychange", run);
    const timer = window.setInterval(run, 60 * 60 * 1000);
    return () => { document.removeEventListener("visibilitychange", run); window.clearInterval(timer); };
  }, [dashboards, meals]);
}
